import React from 'react';
import './styles.css';

const GithubIcon = () => (
  <svg
    className="githubIcon"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 120.8 117.8"
    enableBackground="new 0 0 120.8 117.8"
  >
    <g className="githubIconPaths">
      <path
        id="XMLID_24_"
        fillRule="evenodd"
        fill="#1D1C15"
        d="M60.4,0C27,0,0,27,0,60.4
                c0,26.7,17.3,49.3,41.3,57.3c3,0.6,4.1-1.3,4.1-2.9c0-1.4-0.1-6.2-0.1-11.2C28.5,107.2,25,96.4,25,96.4c-2.7-7-6.7-8.8-6.7-8.8
                c-5.5-3.7,0.4-3.7,0.4-3.7c6.1,0.4,9.3,6.2,9.3,6.2c5.4,9.2,14.1,6.6,17.6,5c0.5-3.9,2.1-6.6,3.8-8.1C36,85.6,21.9,80.4,21.9,57.2
                c0-6.6,2.4-12,6.2-16.2c-0.6-1.5-2.7-7.7,0.6-16c0,0,5.1-1.6,16.6,6.2c4.8-1.3,10-2,15.1-2c5.1,0,10.3,0.7,15.1,2
                C87,23.4,92.1,25,92.1,25c3.3,8.3,1.2,14.5,0.6,16c3.9,4.2,6.2,9.6,6.2,16.2c0,23.2-14.1,28.3-27.6,29.8c2.2,1.9,4.1,5.5,4.1,11.2
                c0,8.1-0.1,14.6-0.1,16.6c0,1.6,1.1,3.5,4.1,2.9c24-8,41.3-30.6,41.3-57.3C120.8,27,93.7,0,60.4,0z"
      />
      <path
        id="XMLID_21_"
        fill="#1D1C15"
        d="M22.9,86.7c-0.1,0.3-0.6,0.4-1,0.2c-0.4-0.2-0.7-0.6-0.5-0.9c0.1-0.3,0.6-0.4,1-0.2
                C22.8,86,23,86.4,22.9,86.7L22.9,86.7z M22.1,86.2"
      />
      <path
        id="XMLID_18_"
        fill="#1D1C15"
        d="M25.3,89.4c-0.3,0.3-0.9,0.1-1.2-0.3c-0.4-0.4-0.5-1-0.2-1.3c0.3-0.3,0.8-0.1,1.2,0.3
                C25.5,88.6,25.6,89.2,25.3,89.4L25.3,89.4z M24.7,88.8"
      />
      <path
        id="XMLID_15_"
        fill="#1D1C15"
        d="M27.7,92.9c-0.4,0.3-1,0-1.3-0.5c-0.4-0.5-0.4-1.2,0-1.4c0.4-0.3,1,0,1.3,0.5
                C28.1,92,28.1,92.6,27.7,92.9L27.7,92.9z M27.7,92.9"
      />
      <path
        id="XMLID_12_"
        fill="#1D1C15"
        d="M31,96.3c-0.3,0.4-1,0.3-1.6-0.2c-0.5-0.5-0.7-1.2-0.3-1.5c0.3-0.4,1-0.3,1.6,0.2
                C31.2,95.2,31.3,95.9,31,96.3L31,96.3z M31,96.3"
      />
      <path
        id="XMLID_9_"
        fill="#1D1C15"
        d="M35.5,98.2c-0.1,0.5-0.8,0.7-1.5,0.5c-0.7-0.2-1.1-0.8-1-1.2c0.1-0.5,0.8-0.7,1.5-0.5
                C35.2,97.2,35.6,97.7,35.5,98.2L35.5,98.2z M35.5,98.2"
      />
      <path
        id="XMLID_6_"
        fill="#1D1C15"
        d="M40.4,98.6c0,0.5-0.6,0.9-1.3,0.9c-0.7,0-1.3-0.4-1.3-0.9c0-0.5,0.6-0.9,1.3-0.9
                C39.8,97.7,40.4,98.1,40.4,98.6L40.4,98.6z M40.4,98.6"
      />
      <path
        id="XMLID_3_"
        fill="#1D1C15"
        d="M45,97.8c0.1,0.5-0.4,1-1.1,1.1c-0.7,0.1-1.3-0.2-1.4-0.7c-0.1-0.5,0.4-1,1.1-1.1
                C44.3,97,44.9,97.3,45,97.8L45,97.8z M45,97.8"
      />
    </g>
  </svg>
);

export default GithubIcon;
